/* Cufon generated fonts already registered with Raphael */

require('./font/handlee_400.font');
require('./font/pacifico_400.font');
require('./font/yellowtail_400.font');

var Backbone = require('backbone'),
    _ = require('underscore');



module.exports = Backbone.Model.extend({

    /**
     * Possible font families from which to choose.
     * Note -- the actually css @font-face styles are all suffixed with 'regular' --
     * in cufon generator this was removed for this js files
    */
    fonts: [
        'handlee',
        'pacifico',
        'yellowtail'
    ],

    /** Default color now defined on signature note model */
    defaults: {
        activeFont: 'handlee',
        baseFontSize: '36px',
        showBottomText: false,
        cursor: 'pointer' // always selected when created
    },

    /* used in template */
    fontNamesHash: function() {
        return _.object( this.fonts, this._getStyleSheetFontNames() );
    },

    _getStyleSheetFontNames: function() {

        return _.map( this.fonts, function( fname ) {
            return fname + 'regular';
        });

    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/signature/signatureUIModel.js
 ** module id = 216
 ** module chunks = 0
 **/